import { createReducer, on } from '@ngrx/store';
import * as userActions from '../actions/user.actions';

export const initialUserState = null;

export const userReducer = createReducer(
    initialUserState,
    on(userActions.GetUserSuccess, (state, action) => {
        localStorage.setItem('userAccount', JSON.stringify(action))
        return Object.assign({}, action)
    }),
    on(userActions.ClearUser, (state, action) => initialUserState)
);
